<div class="aip-board">

    <div class="aip-board-container" [ngClass]="{ 'account-list-container': !isData }">
        <div *ngIf="sAccount" class="account-header-container">
            <div class="account-info-container">
                <div class="account-page-info-container">
                    <span *ngIf="getLogo(this.sAccount)!=''" class="account-image-container">
                        <img [matTooltip]="this.sAccount['name']" class="image-fit" [src]="'/logos/'+getLogo(this.sAccount)">
                    </span>
                    <div class="account-page-info">
                        <div><span class="aip-primary-color">{{ this.sAccount["name"] }}</span></div>
                        <div>{{ page==1 ? 'Service Landscape Use Cases' : page==2 ? 'Service Landscape View' : page == 3 ? 'Service Health Assessment View' : page == 4 ? 'Asset Map' : page == 5 ? 'Voice of Customer & Stakeholders' : 'Heading'}}</div>
                    </div>
                </div>
                <div *ngIf="this.sVersionName!=''" class="previous-version-name">Previous Version Selected: <span class="aip-primary-color">{{this.sVersionName}}</span></div>
            </div>

            <div class="aip-viewname-right">
                <ng-container>
                    <div class="pagination-container">
                        <button [disabled]="page==1" mat-raised-button class="aip-board-button" (click)="pageDown()">
                            <fa-icon class="" icon="chevron-circle-left"></fa-icon>
                        </button>
                        <span style="width:80px;text-align: center;display: inline-block;">Page {{page}} of 4</span>
                        <button [disabled]="page==4"  mat-raised-button class="aip-board-button" (click)="pageUp()">
                            <fa-icon class="" icon="chevron-circle-right"></fa-icon>
                        </button>
                    </div>
                </ng-container>
                <div>
                    <ng-container>
    
                        <mat-checkbox [(ngModel)]="healthHideEntities" class="toolbar-check" *ngIf="page==3 && this.showEditable" matTooltip="Hide Entities without Health Status">Hide Entities without Health Status</mat-checkbox>
        
                        <ng-container *ngIf="this.showEditable" >
                        <button matTooltip="Add an Entity" *ngIf="page==2"  mat-raised-button class="aip-board-button" (click)="addEntity()" [disabled]="!isData">
                            <fa-icon class="" icon="plus"></fa-icon>
                        </button>
        
                        <button matTooltip="Edit Account Status values" *ngIf="page==1"  mat-raised-button class="aip-board-button" (click)="openStatusEdit()" [disabled]="!isData">
                            <fa-icon class="" icon="edit"></fa-icon>
                        </button>
        
                        <button matTooltip="Edit Asset Map values"  *ngIf="page==4"  mat-raised-button class="aip-board-button" (click)="openAssetMapEdit()" [disabled]="!isData">
                            <fa-icon class="" icon="edit"></fa-icon>
                        </button>
        
                        </ng-container>                
        
                        <button *ngIf="useNewLayout && (page == 2 || page == 3)" [matTooltip]="getPageViewTooltip()" mat-raised-button class="aip-board-button" (click)="updatePageView()">
                            <mat-icon [svgIcon]="pageViews[pageView - 1] + '-view-icon'" aria-hidden="false" style="width: 18px;"></mat-icon>
                        </button>
        
                        <mat-button-toggle-group class="aip-button-toggle" [(ngModel)]="tableView" (change)="toggleTableView()">
                            <mat-button-toggle matTooltip="Show Visual View" value="regular"><fa-icon icon="star"></fa-icon></mat-button-toggle>
                            <mat-button-toggle matTooltip="Show Table View" value="table"><fa-icon icon="list-alt"></fa-icon></mat-button-toggle>
                        </mat-button-toggle-group>
        
                        <button  matTooltip="Select a Version"  mat-raised-button class="aip-board-button" (click)="openVersions()" [disabled]="!isData">
                            <fa-icon class="" icon="history"></fa-icon>
                        </button>
        
                        <button class="aip-board-button" mat-raised-button class="aip-board-button" [matMenuTriggerFor]="menu" matTooltip="Import/Export File">
                            <fa-icon class="fa-rotate-90" style="display:inline-block" icon="exchange-alt"></fa-icon>
                        </button>
        
                        <mat-menu #menu="matMenu">
                            <button matTooltip="Export Excel" mat-menu-item (click)="excel()" [disabled]="!isData">
                                <fa-icon class="" icon="file-excel"></fa-icon>
                                <span class="excel-menu" >Export to Excel</span>
                            </button>
                            <button matTooltip="Export Powerpoint" mat-menu-item (click)="powerpoint()" [disabled]="!isData">
                                <fa-icon class="" icon="file-powerpoint"></fa-icon>
                                <span class="excel-menu" >Export to Powerpoint</span>
                            </button>
                            <button matTooltip="Print / Export As PDF" mat-menu-item (click)="print()" [disabled]="!isData">
                                <fa-icon class="" icon="file-pdf"></fa-icon>
                                <span class="excel-menu" >Print / Export As PDF</span>
                            </button>
                            <ng-container *ngIf="this.showEditable" >
                                <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;">
                                <button matTooltip="Import Excel" mat-menu-item (click)="file.click()" [disabled]="!isData">
                                    <fa-icon class="" icon="file-upload"></fa-icon>
                                    <span class="excel-menu" >Import Excel</span>
                                </button>
                            </ng-container>
                        </mat-menu>              
        
                        <button matTooltip="Related Accounts" *ngIf="this.subAccounts.length>0" mat-raised-button class="aip-board-button" (click)="viewAccounts('child')" [disabled]="!isData">
                            <fa-icon class="" icon="sitemap"></fa-icon>
                        </button>
                    </ng-container>
        
                </div>
            </div>
        </div>
        
        <mat-divider *ngIf="sAccount" class="aip-view-divider"></mat-divider>

        <div *ngIf="this.isLoading || this.init || this.isLoadingUser || this.isUpdateEntity" class="spinner-container">
            <mat-spinner diameter=50 class="aip-topol-spinner"></mat-spinner>
        </div>
        <ng-container *ngIf="!this.isLoading && !this.init && !this.isLoadingUser">
            <ng-container *ngIf="!this.isData">
                <div cdkScrollable class="stage">
                    <div class="stage-view">
                        <app-account-filtering #filtering [showRestrictedFilter]="showRestrictedFilter" [isAdmin]="isAdmin" [clearSession]="clearSession" (resetSessionFlag)="resetSessionFlag($event)"></app-account-filtering>
                    </div>
                </div>
            </ng-container>
    
            <ng-container *ngIf="this.isData">
    
                <div *ngIf="(page==2 || page==3) && tableView=='regular'" class="stage">
    
                    <div class="stage-view" [ngClass]="{ 'readonly': !showEditable, 'height-fit-content': fitHeight, 'width-fit-content': fitWidth }" [ngStyle]="{transform: 'scale('+ getScale() +')'}">                        
                        <ng-container *ngIf="useNewLayout; else oldSlViewTemplate">
                            <app-sl-view-new #slview [showEditable]="showEditable" [entitiesData]="entitiesData" [sAccount]="sAccount" [sVersion]="sVersion" [entityViewType]="this.page==2?'landscape':'health'" [healthHideEntities]="healthHideEntities" [pageView]="pageView" [stackColors]="stackColors"></app-sl-view-new>
                        </ng-container>
                        <ng-template #oldSlViewTemplate>
                            <app-sl-view #slview [showEditable]="showEditable" [entitiesData]="entitiesData" [sAccount]="sAccount" [sVersion]="sVersion" [entityViewType]="this.page==2?'landscape':'health'" [healthHideEntities]="healthHideEntities" [pageView]="pageView"></app-sl-view>
                        </ng-template>
                    </div>
                </div>
    
                <div *ngIf="page==1 && tableView=='regular' && !isLoadingStatus" class="stage">
                    <div class="stage-view" [ngClass]="{ 'readonly': !showEditable, 'height-fit-content': fitHeight, 'width-fit-content': fitWidth }" [ngStyle]="{transform: 'scale('+ getScale() +')'}">
                        <app-sl-use-cases #slusecases [showEditable]="showEditable" [accountsStatusData]="accountsStatus" [sAccount]="sAccount" [sVersion]="sVersion" [useNewLayout]="useNewLayout"></app-sl-use-cases>
                    </div>
                </div>
    
                <div *ngIf="page==4 && tableView=='regular'" class="stage">
                    <div class="stage-view" [ngClass]="{ 'readonly': !showEditable, 'height-fit-content': fitHeight, 'width-fit-content': fitWidth }" [ngStyle]="{transform: 'scale('+ getScale() +')'}">
                        <ng-container *ngIf="useNewLayout; else oldSlAssetMapTemplate">
                            <app-sl-asset-map-new #slassetmap [showEditable]="showEditable" [assetMapData]="assetMapData" [sAccount]="sAccount" [sVersion]="sVersion" [stackColors]="stackColors"></app-sl-asset-map-new>
                        </ng-container>
                        <ng-template #oldSlAssetMapTemplate>
                            <app-sl-asset-map #slassetmap [showEditable]="showEditable" [assetMapData]="assetMapData" [sAccount]="sAccount" [sVersion]="sVersion"></app-sl-asset-map>
                        </ng-template>
                    </div>
                </div>
    
    
                <div *ngIf="page==1 && tableView=='table'" class="stage">
                    <mat-card class="aip-widget-fullscreen mat-elevation-z4">
                    <app-table-grid class="table" [tableDef]="accountStatusTableDef" [data]="accountsStatusData" [loading]="loading" (reload)="loadAccountData()"></app-table-grid>
                    </mat-card>
                </div>
    
                <div *ngIf="(page==2 || page==3) && tableView=='table'" class="stage">
                    <mat-card class="aip-widget-fullscreen mat-elevation-z4">
                    <app-table-grid class="table" [tableDef]="entitiesTableDef" [data]="entitiesData" [loading]="loading" (reload)="loadAccountData()"></app-table-grid>
                    </mat-card>
                </div>
    
                <div *ngIf="page==4 && tableView=='table'" class="stage">
                    <mat-card class="aip-widget-fullscreen mat-elevation-z4">
                    <app-table-grid class="table" [tableDef]="assetMapTableDef" [data]="assetMap" [loading]="loading" (reload)="loadAccountData()"></app-table-grid>
                    </mat-card>
                </div>
                <div *ngIf="page==5" class="stage">
                    <div class="stage-view" [ngClass]="{ 'readonly': !showEditable, 'height-fit-content': fitHeight, 'width-fit-content': fitWidth }" [ngStyle]="{transform: 'scale('+ getScale() +')'}">
                       <app-voice-of-customer></app-voice-of-customer>
                    </div>
                </div>
    
            </ng-container>
        </ng-container>
    </div>

    <div class="footer">
        <span class="confidential">DXC Confidential - not for external use</span>
        <span class="spacer"></span>

        <ng-container *ngIf="this.isData && tableView=='regular'">
            <button matTooltip="Zoom Out" matTooltipShowDelay="1000" mat-button class="footer-button size-button" (click)="zoomMinus()"><fa-icon icon="minus" ></fa-icon></button>
            <mat-slider matTooltip="Zoom" matTooltipShowDelay="1000" class="zoom" min="10" max="200" step="5" [(ngModel)]="zoom"></mat-slider>
            <button matTooltip="Zoom In" matTooltipShowDelay="1000" mat-button class="footer-button size-button" (click)="zoomPlus()"><fa-icon icon="plus" ></fa-icon></button>
            <span matTooltip="Zoom Level - Click to reset to 100%" matTooltipShowDelay="1000" class="footer-zoom" (click)="zoom=100">{{zoom}}%</span>
            <button matTooltip="Fit Page" matTooltipShowDelay="1000" mat-button class="footer-button" (click)="zoomFit()"><fa-icon icon="expand-arrows-alt"></fa-icon></button>
        </ng-container>
    </div>

</div>
